import InternalStaticAnchorBattlesV2 from 'models/application/anchor/types/internalStatic/types/BattlesV2';

export default class InternalStaticAnchorBattlesV2Service {
	toModel() {
		return new InternalStaticAnchorBattlesV2();
	}
}
